import React, { useState } from 'react';
import { Button, MainContent, SubTitle, } from '../../../../../components/StyledComponents';
import { validarCnpj } from '../../../../../utils/utils';
import { ConsultarEmpreendedorService } from "../../../../../services/consultarEmpreendedorService";
import TextAreaInput from "../../../../../components/TextAreaInput";
import { Grid } from "@mui/material";
import { retirarMascara } from "../../../../../utils/mask";
import InputMask from "../../../../../components/InputMask";
import styles from "../../../../../components/TableAdmin/styles.module.scss";
import Spinner from "react-spinner-material";


export const Gerenciar = () => {
  
  const [isLoading, setIsLoading] = useState(false);
  const [cnpj, setCNPJ] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  

  const getData = async () => {
    setError(null)
    const unsmakedCNPJ = retirarMascara(cnpj);
    
    if (!cnpj || !validarCnpj(unsmakedCNPJ)) {
      setError("CNPJ Inválido");
      return
    }
    
    try {
      setIsLoading(true);
      const response = await ConsultarEmpreendedorService.find(unsmakedCNPJ);
      setData(response);
      setError(null);
    } catch (error) {
      const descricao = error.response?.data?.message?.descricao
      console.log('descricao', descricao);
      if (descricao?.includes("empreendedor não localizado pelo cnpj")) {
        setError("CNPJ não encontrado");
        return;
      }
    } finally {
      setIsLoading(false);
    }
  };
  
  
  return (
      <MainContent>
        <SubTitle>
          <>
            <h3>Gerenciar</h3>
          </>
        </SubTitle>
        
        <Grid container alignItems="flex-start" sx={{mb: 2}}>
          <Grid item md={3} sx={{mt: 2}}>
            <InputMask
                mask="99.999.999/9999-99"
                error={error}
                label={'CNPJ'}
                onChange={(value) => setCNPJ(value)}
                value={cnpj}
                showMaxLengthLabel={false}
                maxLength={18}
            />
          </Grid>
          
          <Grid item md={3} sx={{mt: 5, ml: 1}}>
            <Button href="#" onClick={() => getData()}>
              Consultar
            </Button>
          </Grid>
        </Grid>
  
  
        {isLoading && (
            <div className={styles.spinnerCenter}>
              <Spinner radius={80} color={'#0061C6'} stroke={2} visible={true} />
              <p>Carregando...</p>
            </div>
        )}
        
        {
          !!data && (
              <TextAreaInput
                  label={"Informações"}
                  readOnly={true}
                  width={'90%'}
                  disabled={true}
                  onChange={() => console.log('changed')}
                  height={"700px"}
                  value={JSON.stringify(data, null, 2)}
              />
          )
        }
      
      </MainContent>
  );
};
